import FlexItemBase from './_flex-item-base.js'
import ConfigurableFlex from './_configurable-flex.js'
import ConfigurablePane from './_configurable-pane.js'
import ConfigurableSizeBounds from './_configurable-size-bounds.js'
import ConfigurableMargin from './_configurable-margin.js'

export default {
  name: 'Button',
  values: {
    enableAHref: false,
    inline: false,
    triggerCustomEvent: true,
    style: {
      base: {
        position: 'relative',
        cursor: 'pointer',
        justifyContent: 'center',
        textDecoration: 'none',
        WebkitTapHighlightColor: 'transparent',
        outline: 'none',
        overflow: 'visible',
        $mixin: [
          {
            configSet: FlexItemBase,
          },
          {
            configSet: ConfigurableFlex,
          },
          {
            configSet: ConfigurablePane,
          },
          {
            configSet: ConfigurableSizeBounds,
          },
          {
            configSet: ConfigurableMargin,
          },
        ],
      },
      hover: {
        $mixin: [
          {
            configSet: ConfigurablePane,
          },
        ],
      },
      active: {
        $mixin: [
          {
            configSet: ConfigurablePane,
          },
        ],
      },
      disabled: {
        cursor: 'default',
        $mixin: [
          {
            configSet: ConfigurablePane,
          },
        ],
      },
    },
  },
  meta: {
    extendable: false,
  },
}
